// @flow
import { REQUESTS_BACKEND_URL } from "../../Constants/Global/apiConstants";
import axios from "axios";
import { getPhoneNumberUnmasked } from "../../Utilities/Helpers/InputMaskHelpers";

export function submitInitialRequestForm(formElements: Object) {
  formElements.telephone_number = getPhoneNumberUnmasked(formElements.telephone_number);

  return axios.create({
    method: "post",
    headers: { "Content-Type": "application/json" },
    url: `${REQUESTS_BACKEND_URL}/initialrequest/create`,
    data: formElements
  })
}



// WEBPACK FOOTER //
// ./src/Api/PublicAccountPages/initialrequest.js